import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import AssessmentIcon from '@material-ui/icons/Assessment';
import Chip from '@material-ui/core/Chip';
import CircularChart from '../components/CircularChart';
import BarChart from '../components/BarChart';
import confettiImg from '../../images/confetti_background.jpg';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import { getVoteStatistics } from '../services/edition';
import LinearChart from '../components/LinearChart';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TimelineIcon from '@material-ui/icons/Timeline';
import todoImg from '../../images/undraw_To_do_list_re_9nt7.png';
import voteImg from '../../images/undraw_voting_nvu7.png';
import internetVoteImg from '../../images/undraw_posting_photo_v65l.png';
import paperVoteImg from '../../images/undraw_attached_file_n4wm.png';
import Wrapper from '../components/Wrapper';
import WonProjectsList from './WonProjectsList';
import SimpleBox from './SimpleBox';

const useStyles = makeStyles((theme) => ({
  header: {
    position: 'relative',
    backgroundImage: `url(${confettiImg})`,
    backgroundPosition: 'center',
    backgroundSize: '100% auto',
    height: '28rem',
    marginBottom: 30,
    borderRadius: 3,
    [theme.breakpoints.down('xs')]: {
      backgroundPosition: 'bottom',
    },
  },
  headerContent: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    padding: 20,
    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#004c82',
      top: '0',
      left: 0,
      right: 0,
      height: 'max-content',
      color: '#fff',
      padding: '20px',
    },
  },
  tab: {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  tabSelected: {
    color: theme.palette.primary.main,
  },
  statisticContainer: {
    width: '100%',
    marginTop: 25,
    display: 'grid',
    gap: '1rem',
    [theme.breakpoints.up('xs')]: {
      gridTemplateColumns: '100%',
      gridTemplateAreas:
        "'projectCount' 'projectsAmount' 'projectsApproved' 'projectsVictorious''votesNumber' 'votesPeople''projectsCategories' 'votingPlace' 'barChart'",
    },
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 50%)',
      gridTemplateAreas:
        "'projectCount projectsAmount' 'projectsApproved projectsVictorious''votesNumber votesNumber' 'votesPeople votesPeople''projectsCategories projectsCategories' 'votingPlace votingPlace' 'barChart barChart'",
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(4, 25%)',
      gridTemplateAreas:
        "'projectCount projectsAmount projectsApproved projectsVictorious''votesNumber votesNumber votesPeople votesPeople''projectsCategories projectsCategories projectsCategories projectsCategories' 'votingPlace votingPlace votingPlace votingPlace' 'barChart barChart barChart barChart'",
    },
    '& > div': {
      backgroundColor: '#FFF',
    },
  },
  simpleBoxDouble: {
    padding: '20px 15px',
    height: 175,
    backgroundColor: theme.palette.background.white,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  forceh4: {
    fontSize: '2.28rem',
    lineHeight: '110%',
  },
  forceh5: {
    fontSize: '1.5rem',
    fontWeight: 400,
    lineHeight: '1.334',
    letterSpacing: '0em',
  },
}));

const Statistics = ({ edition, date_start, date_end }) => {
  const classes = useStyles();
  const [service, setService] = useState(0);
  const [editionStatistics, setEditionStatistics] = useState({
    name: '',
    projects_approved: {
      count: 0,
      percent: 0,
    },
    projects_victorious: {
      count: 0,
      percent: 0,
    },
    projects_categories: {
      district: 0,
      city: 0,
    },
    projects_count: {
      district: 0,
      city: 0,
    },
    votes_number: 0,
    votes_people: { backoffice: 0, frontoffice: 0, all: 0 },
    votes_per_day: [],
  });

  useEffect(() => {
    getVoteStatistics(edition)
      .then(({ data }) => {
        setEditionStatistics({
          name: data.name,
          projects_approved: data.projects_approved,
          projects_categories: data.projects_categories,
          projects_count: data.projects_count,
          projects_victorious: data.projects_victorious,
          votes_number: data.votes_number,
          votes_people: data.votes_people,
          votes_per_day: data.votes_per_day,
        });
      })
      .catch((error) => console.error(error));
  }, [edition]);

  const handleServiceChange = (event, newValue) => {
    setService(newValue);
  };

  const countPercentage = (amount, all) => {
    const result = (amount / all) * 100;
    return Math.round(result);
  };

  const chartsColors = {
    projectsApproved: '#FF9800',
    projectsVictorious: '#4CAF50',
  };

  return (
    <div>
      <header className={classes.header}>
        <div className={classes.headerContent}>
          <h2 className={classes.forceh4}>Wyniki głosowania</h2>
          <h3 className={classes.forceh5}>Sprawdź, które pomysły zwyciężyły</h3>
        </div>
      </header>
      <Tabs
        value={service}
        onChange={handleServiceChange}
        indicatorColor='primary'
      >
        <Tab
          label='Wyniki'
          icon={<EmojiEventsIcon />}
          className={classes.tab}
          classes={{
            selected: classes.tabSelected,
          }}
        />
        <Tab
          label='Statystyki'
          icon={<TimelineIcon />}
          className={classes.tab}
          classes={{
            selected: classes.tabSelected,
          }}
        />
      </Tabs>
      {service === 0 && <WonProjectsList editionId={edition} />}
      {service === 1 && (
        <div className={classes.statisticContainer}>
          <SimpleBox
            data={[
              {
                title: 'Złożonych projektów',
                value:
                  editionStatistics.projects_count.district +
                  editionStatistics.projects_count.city,
                text: 'W edycji:',
                chip: (
                  <Chip
                    title={editionStatistics.name}
                    label={editionStatistics.name}
                    color='primary'
                    size='small'
                  />
                ),
              },
            ]}
            gridArea='projectCount'
          />
          <SimpleBox
            data={[
              {
                title: 'Projekty dzielnicowe',
                titleHeader: true,
                text: editionStatistics.projects_count.district,
                icon: <MyLocationIcon />,
              },
              {
                title: 'Projekty ogólnomiejskie',
                titleHeader: true,
                text: editionStatistics.projects_count.city,
                icon: <LocationCityIcon />,
              },
            ]}
            column
            gridArea='projectsAmount'
          />
          <CircularChart
            projectsNumber={
              editionStatistics.projects_count.district +
              editionStatistics.projects_count.city
            }
            value={editionStatistics.projects_approved.count}
            percentValue={editionStatistics.projects_approved.percent}
            label='projekty poddane pod głosowanie'
            color={chartsColors.projectsApproved}
            icon={
              <AssessmentIcon
                style={{ color: chartsColors.projectsApproved }}
              />
            }
            gridArea='projectsApproved'
          />
          <CircularChart
            projectsNumber={
              editionStatistics.projects_count.district +
              editionStatistics.projects_count.city
            }
            value={editionStatistics.projects_victorious.count}
            percentValue={editionStatistics.projects_victorious.percent}
            label='projekty zwycięskie'
            color={chartsColors.projectsVictorious}
            icon={
              <EmojiEventsIcon
                style={{ color: chartsColors.projectsVictorious }}
              />
            }
            gridArea='projectsVictorious'
          />
          <SimpleBox
            data={[
              {
                title: 'Liczba wszystkich głosów',
                value: editionStatistics.votes_number,
                text: '',
                image: todoImg,
                alt: 'Arkusz głosowania',
                centerTexts: true,
              },
            ]}
            gridArea='votesNumber'
          />
          <SimpleBox
            data={[
              {
                title: 'Liczba osób głosujących',
                value: editionStatistics.votes_people.all,
                text: '',
                image: voteImg,
                alt: 'Głosujący ludzie',
                centerTexts: true,
              },
            ]}
            gridArea='votesPeople'
          />
          <LinearChart
            districtProjectNumber={
              editionStatistics.projects_categories?.district ?? '-'
            }
            cityProjectNumber={
              editionStatistics.projects_categories?.city ?? '-'
            }
            label='Podział głosów na kategorie projektów'
            gridArea='projectsCategories'
          />
          <SimpleBox
            refactor={true}
            data={[
              {
                value: editionStatistics.votes_people.frontoffice,
                text: `${countPercentage(
                  editionStatistics.votes_people.frontoffice,
                  editionStatistics.votes_people.all,
                )}% osób głosowało przez internet`,
                image: internetVoteImg,
                alt: 'Głosowanie przez internet',
              },
              {
                value: editionStatistics.votes_people.backoffice,
                text: `${countPercentage(
                  editionStatistics.votes_people.backoffice,
                  editionStatistics.votes_people.all,
                )}% osób głosowało w formie papierowej`,
                image: paperVoteImg,
                alt: 'Głosowanie w formie papierowej',
              },
            ]}
            gridArea='votingPlace'
          />
          <BarChart
            gridArea='barChart'
            label='Głosowanie dzień po dniu'
            title='Liczba osób głosujących przez internet z podziałem na dni'
            text=''
            dateStart={date_start}
            dateEnd={date_end}
            votesPerDay={editionStatistics.votes_per_day}
          />
        </div>
      )}
    </div>
  );
};

export default Statistics;

ReactDOM.render(
  <Wrapper productionPrefix='sta' seed='statistics'>
    <Statistics edition={edition} date_start={date_start} date_end={date_end} />
  </Wrapper>,
  document.getElementById('cms-voting-statistics'),
);
